import React from 'react';

const s = {
  page: { padding: '2rem', maxWidth: '820px', margin: '0 auto', fontFamily: 'DM Sans, sans-serif' } as React.CSSProperties,
  card: { background: '#1a1a30', borderRadius: '16px', padding: '2rem', border: '1px solid #2a2a4a', color: '#c0c0e0', lineHeight: 1.8 } as React.CSSProperties,
  h2: { color: '#fff', margin: '1.75rem 0 0.75rem', fontSize: '1.05rem' } as React.CSSProperties,
  h3: { color: '#e0e0f0', margin: '1.25rem 0 0.5rem', fontSize: '0.95rem' } as React.CSSProperties,
  p: { marginBottom: '0.75rem' } as React.CSSProperties,
  ul: { paddingLeft: '1.5rem', marginBottom: '0.75rem' } as React.CSSProperties,
  tableWrap: { background: '#12121f', borderRadius: '10px', overflow: 'hidden', marginBottom: '1rem' } as React.CSSProperties,
  th: { padding: '0.6rem 0.75rem', textAlign: 'left' as const, color: '#fff', background: '#1F4E79', fontSize: '0.85rem' },
  td: { padding: '0.6rem 0.75rem', fontSize: '0.85rem', borderBottom: '1px solid #2a2a4a' },
  info: { background: '#1a1a38', padding: '1rem', borderRadius: '8px', color: '#8080c0', marginBottom: '1rem' } as React.CSSProperties,
};

const Table: React.FC<{ headers: string[]; rows: (string | React.ReactNode)[][] }> = ({ headers, rows }) => (
  <div style={s.tableWrap}>
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>{headers.map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i} style={{ background: i % 2 === 0 ? 'transparent' : '#1a1a2e' }}>
            {row.map((cell, j) => <td key={j} style={s.td}>{cell}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const Cookies: React.FC = () => (
  <div style={s.page}>
    <h1 style={{ color: '#fff', marginBottom: '0.5rem' }}>🍪 Politica de Cookies</h1>
    <p style={{ color: '#6060a0', fontSize: '0.85rem', marginBottom: '2rem' }}>Versiunea 1.0 | În vigoare: 03.06.2026</p>

    <div style={s.card}>

      <h2 style={{ ...s.h2, marginTop: 0 }}>1. Ce sunt cookie-urile?</h2>
      <p style={s.p}>Cookie-urile sunt fișiere text de mici dimensiuni pe care un site web le plasează în browserul tău atunci când îl vizitezi. Acestea permit site-ului să îți recunoască browserul la vizite ulterioare, să rețină preferințele tale și să funcționeze corect.</p>
      <p style={s.p}>Prezenta politică se aplică site-ului flexara.ro și este elaborată în conformitate cu Regulamentul UE 2016/679 (GDPR) și Legea nr. 506/2004 privind prelucrarea datelor cu caracter personal și protecția vieții private în sectorul comunicațiilor electronice.</p>

      <h2 style={s.h2}>2. Ce cookie-uri folosim?</h2>

      <h3 style={s.h3}>2.1 Cookie-uri strict necesare</h3>
      <p style={s.p}>Aceste cookie-uri sunt indispensabile pentru funcționarea de bază a Platformei. Nu pot fi dezactivate.</p>
      <Table
        headers={['Nume cookie', 'Scop', 'Durata']}
        rows={[
          ['flexara_consent', 'Reține opțiunile tale de consimțământ cookies', '12 luni'],
          ['flexara_session', 'Menține sesiunea activă în browser', 'Sesiune'],
          ['XSRF-TOKEN', 'Protecție împotriva atacurilor CSRF', 'Sesiune'],
        ]}
      />
      <div style={s.info}>
        ℹ️ Autentificarea în Flexara se realizează prin token JWT stocat în localStorage (nu în cookie-uri), pentru compatibilitate cu arhitectura aplicației.
      </div>

      <h3 style={s.h3}>2.2 Cookie-uri de preferințe</h3>
      <p style={s.p}>Aceste cookie-uri rețin setările și preferințele tale (ex: tema) pentru a îți oferi o experiență personalizată. Sunt activate doar cu consimțământul tău.</p>
      <Table
        headers={['Nume cookie', 'Scop', 'Durata']}
        rows={[
          ['flexara_prefs', 'Preferințe de interfață (temă)', '6 luni'],
        ]}
      />

      <h3 style={s.h3}>2.3 Cookie-uri analitice</h3>
      <p style={s.p}>Aceste cookie-uri ne ajută să înțelegem cum este utilizată Platforma pentru a îmbunătăți experiența utilizatorilor. Sunt activate doar cu consimțământul tău.</p>
      <div style={s.info}>
        ℹ️ În prezent, Platforma nu utilizează cookie-uri analitice de la terți. Această secțiune va fi actualizată dacă vom integra un serviciu de analiză.
      </div>

      <h3 style={s.h3}>2.4 Cookie-uri de la terți</h3>
      <p style={s.p}>Anumiți furnizori externi cu care colaborăm pot plasa cookie-uri proprii în browserul tău.</p>
      <Table
        headers={['Furnizor', 'Scop', 'Politica de confidențialitate']}
        rows={[
          ['Stripe', 'Procesarea plăților online', <a href="https://stripe.com/privacy" style={{ color: '#4a4ad8' }} target="_blank" rel="noreferrer">stripe.com/privacy</a>],
          ['Anthropic', 'Furnizare servicii AI (chat)', <a href="https://www.anthropic.com/privacy" style={{ color: '#4a4ad8' }} target="_blank" rel="noreferrer">anthropic.com/privacy</a>],
        ]}
      />
      <p style={s.p}>Cookie-urile Anthropic sunt activate doar atunci când utilizezi funcționalitatea de chat. Anthropic procesează mesajele conform propriilor termeni.</p>

      <h2 style={s.h2}>3. Cum poți controla cookie-urile?</h2>

      <h3 style={s.h3}>3.1 Banner de consimțământ</h3>
      <p style={s.p}>La prima vizită pe flexara.ro, vei fi întâmpinat de un banner de consimțământ unde poți accepta toate cookie-urile, accepta doar cele strict necesare sau personaliza opțiunile pe categorii. Îți poți modifica opțiunile oricând din Profil &gt; Setări &gt; Preferințe Cookies.</p>

      <h3 style={s.h3}>3.2 Setările browserului</h3>
      <ul style={s.ul}>
        <li><strong>Google Chrome:</strong> Setări &gt; Confidențialitate și securitate &gt; Cookie-uri</li>
        <li><strong>Mozilla Firefox:</strong> Opțiuni &gt; Confidențialitate și securitate</li>
        <li><strong>Safari:</strong> Preferințe &gt; Confidențialitate</li>
        <li><strong>Microsoft Edge:</strong> Setări &gt; Cookie-uri și permisiuni site</li>
      </ul>
      <p style={s.p}>⚠️ Dezactivarea cookie-urilor strict necesare poate afecta funcționarea Platformei.</p>

      <h2 style={s.h2}>4. Stocarea locală (localStorage)</h2>
      <p style={s.p}>Pe lângă cookie-uri, Flexara utilizează localStorage al browserului tău pentru a stoca:</p>
      <ul style={s.ul}>
        <li>Token-ul de autentificare (JWT) — șters la delogare sau la expirarea sesiunii;</li>
        <li>Preferințe de interfață temporare.</li>
      </ul>
      <p style={s.p}>Datele din localStorage nu sunt transmise automat către server la fiecare cerere și rămân exclusiv în browserul tău.</p>

      <h2 style={s.h2}>5. Transferuri internaționale</h2>
      <p style={s.p}>Anumiți furnizori terți (Anthropic, Stripe) pot procesa date în afara Spațiului Economic European, cu garanții adecvate prin mecanisme aprobate de Comisia Europeană (Clauze Contractuale Standard). Detalii în <a href="/confidentialitate" style={{ color: '#4a4ad8' }}>Politica de Confidențialitate</a>.</p>

      <h2 style={s.h2}>6. Modificarea Politicii de Cookies</h2>
      <p style={s.p}>Operatorul poate actualiza prezenta Politică ori de câte ori este necesar. Versiunea actualizată va fi publicată la flexara.ro/cookies cu menționarea datei ultimei modificări. Dacă modificările sunt semnificative, vei fi notificat prin banner la următoarea vizită.</p>

      <h2 style={s.h2}>7. Contact</h2>
      <ul style={s.ul}>
        <li>Email: <a href="mailto:contact@flexara.ro" style={{ color: '#4a4ad8' }}>contact@flexara.ro</a></li>
        <li>Website: <a href="https://flexara.ro" style={{ color: '#4a4ad8' }}>flexara.ro</a></li>
        <li>Operator: SC FLEXDEV SRL, România</li>
        <li>Autoritate de supraveghere: ANSPDCP — <a href="https://www.dataprotection.ro" style={{ color: '#4a4ad8' }} target="_blank" rel="noreferrer">www.dataprotection.ro</a></li>
      </ul>

    </div>
  </div>
);

export default Cookies;
